var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIamBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 273,
    viewBox: "0 0 185 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 169.713C12 187.713 0.2 265.113 0 265.913L184.2 272.013C183.9 271.113 160.6 182.113 158 169.213C155.4 156.313 152.5 149.614 149.4 147.514C146.3 145.413 137.4 141.913 135.5 141.213C135.2 139.813 134.1 139.313 132.6 138.713L131.9 138.413C130.279 137.611 128.566 137.006 126.8 136.613C124.715 136.204 122.673 135.601 120.7 134.813C119.125 134.162 117.618 133.358 116.2 132.413C116.3 131.514 115.8 130.713 115.2 129.613L114.6 128.613C114 127.713 114.1 126.213 114.1 125.013C114.229 124.315 114.195 123.596 114 122.913L113.6 122.213C114.669 122.229 115.716 121.915 116.6 121.313L119.3 119.113C121.802 121.06 123.821 123.559 125.2 126.413L125.5 127.113L126.2 126.613C127.657 125.368 128.966 123.959 130.1 122.413C129.356 123.574 128.484 124.648 127.5 125.613L127.1 125.813L127.7 127.013L126.6 128.313L133.9 130.913L134.1 130.613C142.3 119.313 151.4 96.3135 152.9 74.1135C154.3 54.0135 151.4 39.1135 143.2 24.3135C139.5 17.4135 132.2 10.7135 123.8 6.21348C113.507 0.741847 101.7 -1.19088 90.2 0.713478C78.2085 2.47348 67.1162 8.08988 58.6 16.7135C50.5 24.9135 44.8 35.7135 41.5 48.8135C35.2 73.9135 42.5 111.113 42.6 111.513V111.813L46.6 113.113V112.313C46.3642 106.714 46.4311 101.106 46.8 95.5135C47 105.613 47.7 114.013 47.7 114.113V114.313L47.9 114.513C51.9 118.513 58.7 119.813 58.9 119.913H59.7V119.213C59.2998 113.387 59.2998 107.54 59.7 101.713C60.1393 107.585 60.9072 113.428 62 119.213V119.513H62.3L67.3 122.113L70 123.413L68 121.213C68 121.213 66.5 119.513 66.3 114.313C66.1753 110.879 66.2421 107.44 66.5 104.013C67.1914 109.909 68.2602 115.755 69.7 121.513V121.713L70 121.913L72.1 122.713C71.7753 124.103 71.0847 125.381 70.1 126.413L69.5 127.413C69.0173 127.932 68.7338 128.606 68.7 129.313C67.5619 130.196 66.3192 130.935 65 131.514C60.2456 133.607 55.3296 135.313 50.3 136.613C49.4407 136.719 48.6538 137.148 48.1 137.813L47.9 138.313L34.2 142.213C24.6 145.013 20.4 151.713 16.2 169.713Z",
    fill: "url(#paint0_linear_22_5887)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_5887",
    x1: 92.1,
    y1: 0,
    x2: 92.1,
    y2: 272.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5498FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5498FF",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIamBg);
export default __webpack_public_path__ + "static/media/iam-bg.c1d012ab4939c6e7ad2f3111e6d317a4.svg";
export { ForwardRef as ReactComponent };